	export enum InsurancePriorityEnum {
		Primary = 1,
		Secondary = 2,
		Tertiary = 3,
		Other = 4
	}
